/**
 * Resolução da base da API.
 *
 * Em módulo próprio, sem tocar `window`, para poder ser testado fora do
 * navegador — foi justamente uma falha invisível em desenvolvimento que
 * motivou isolá-la.
 *
 * A checagem de string vazia é essencial, não defensiva: o build de produção
 * define `VITE_API_URL=""` para significar "mesma origem", e `??` só cai no
 * padrão para `null`/`undefined`. Com `""`, o cliente HTTP montava
 * `https://api/me`, tratando o primeiro segmento do caminho como host, e o
 * painel abria em branco com ERR_NAME_NOT_RESOLVED.
 */
export function resolveApiBaseUrl(configured: string | undefined, origin: string): string {
  if (typeof configured !== "string") return origin;
  const trimmed = configured.trim();
  // Barra final removida para não produzir caminhos com barra dupla.
  return trimmed === "" ? origin : trimmed.replace(/\/+$/, "");
}
